import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import firebaseConfig from 'src/config';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject, listAll } from "firebase/storage";
import { getFirestore, collection, onSnapshot, doc, getDoc, getDocs, where, query } from "firebase/firestore";
const app = initializeApp(firebaseConfig);
//firebase.analytics();
const storage = getStorage(app);
const auth = getAuth(app);

// Uploads keep the original file name, so a re-upload replaces the object at the
// same path. 'immutable' is therefore unsafe here: screens would keep serving the
// old bytes for a year. One day of caching still removes ~99% of repeat downloads.
const mediaUploadMetadata = {
  cacheControl: 'public, max-age=86400'
};

export {
  storage,
  mediaUploadMetadata,
  getStorage,
  listAll,
  deleteObject,
  uploadBytes,
  ref,
  doc,
  getDoc,
  query,
  where,
  getDocs,
  getDownloadURL,
  getFirestore,
  onSnapshot,
  collection,
  signInWithPopup, auth as default
};


